import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const domainResolver: FieldResolver = (metadata: Metadata) =>
  ({ domain: metadata.getDomain() } as StreamData)

export default domainResolver
